import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Routers from "./routings/Routers";
import { dsgTheme } from "./styles/theme";

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={dsgTheme}>
        <Router>
          <Navbar />
          <Routers />
          <ToastContainer position="bottom-left" />
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
